import { render, staticRenderFns } from "./Padrao.vue?vue&type=template&id=756f618b&scoped=true&"
import script from "./Padrao.vue?vue&type=script&lang=js&"
export * from "./Padrao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756f618b",
  null
  
)

export default component.exports